import axios from "axios";

// we need to pass the baseURL as an object
const API = axios.create({
  baseURL: process.env.REACT_APP_API,
  // baseURL:'https://37c1-39-40-206-185.ngrok-free.app/api',
});

export default API;